import { Jumbotron, ButtonGroup, Button, Tabs, Tab } from 'react-bootstrap';

const Service = () => {
    return (
        <>
            <Jumbotron>
              <h1>Сервисный центр Синомост</h1>
              <h2></h2>
              <p>
                Мы предоставляем официанльный, качественный сервис на все реализуемые нами позиции. У нас всегда в наличии все детали на всю технику. Мы поставляем любые детали напрямую с завода производителя в самые кратчайшие сроки. Наши специалисты обучены и подготовлены к решению любых проблем связанных с поломкой техники. Вы можете обратиться к нас по гарантии и получить сервисное обслуживание.
              </p>
              <ButtonGroup>
                  <a href="https://wa.me/77015471529" target="_blank" className="btn btn-success">Написать в Whatsapp</a>
                  <a href="tel:+77015471529" className="btn btn-light">Позвонить</a>
              </ButtonGroup>
            </Jumbotron>

            <Tabs defaultActiveKey="cars" id="uncontrolled-tab-example">
              <Tab eventKey="baic" title="BAIC">
                Мы предоставляем гарантийное обслуживание и сервис для автомобилей производства BAIC.
              </Tab>
              <Tab eventKey="dongfeng" title="Dongfeng">
                Мы предоставляем гарантийное обслуживание и сервис для автомобилей производства Dongfeng.
              </Tab>
              <Tab eventKey="foton" title="Foton">
                Мы предоставляем гарантийное обслуживание и сервис для автомобилей производства Foton.
              </Tab>
              <Tab eventKey="equipment" title="Спецтехника">
                Мы предоставляем гарантийное обслуживание и сервис для спецтехники любых производителей Китая. Lonking, Liugong, Lovol, Hyundai, XCMG, KAT, Shacman, Shantui, Sinotruk, HOWO, SANY и др.
              </Tab>
            </Tabs>
        </>
    );
};

export default Service;
